import { render, staticRenderFns } from "./advert.vue?vue&type=template&id=0cd526d4"
import script from "./advert.vue?vue&type=script&lang=ts"
export * from "./advert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports